import React from 'react';

/**
 * Reusable Action Button for DataTables
 * Handles consistent styling, hover effects, and icons.
 */
const TableActionButton = ({
    icon: Icon,
    onClick,
    title,
    variant = 'primary', // 'primary' | 'danger' | 'warning' | 'success' | 'orange'
    className = '',
    disabled = false
}) => {
    const hoverColors = {
        primary: 'hover:text-blue-600',
        danger: 'hover:text-rose-500',
        warning: 'hover:text-amber-500',
        success: 'hover:text-emerald-600',
        orange: 'hover:text-[#ffa000]',
        call: 'hover:text-blue-700 text-blue-500',
        whatsapp: 'hover:text-emerald-500 text-emerald-600',
    };

    const hoverColorClass = hoverColors[variant] || hoverColors.primary;

    return (
        <div className="w-7 h-7 rounded-full flex items-center justify-center border border-slate-200/50 shadow-[inset_1px_1px_2px_rgba(165,175,190,0.4),_inset_-1px_-1px_2px_rgba(255,255,255,0.9)] shrink-0">
            <button
                type="button"
                onClick={onClick}
                disabled={disabled}
                className={`w-5 h-5 rounded-full flex items-center justify-center transition-all duration-300 border border-white
                  ${disabled
                    ? 'bg-slate-50 text-slate-300 opacity-40 cursor-not-allowed shadow-[inset_1px_1px_2px_rgba(0,0,0,0.05)]'
                    : `bg-transparent text-slate-500 shadow-[1.5px_1.5px_3px_rgba(165,175,190,0.4),_-1.5px_-1.5px_3px_rgba(255,255,255,0.95)] hover:bg-[#e6e9ef] hover:shadow-[inset_1.5px_1.5px_3px_rgba(165,175,190,0.5),_inset_-1.5px_-1.5px_3px_rgba(255,255,255,0.9)] cursor-pointer ${hoverColorClass}`
                  } ${className.replace(/hover:!bg-\w+-\d+/g, '')}`}
                title={title}
            >
                {Icon && <Icon className="w-3 h-3" strokeWidth={2.5} />}
            </button>
        </div>
    );
};

export default TableActionButton;